/* eslint-disable max-len */
import { createActions } from 'redux-actions';

const actions = createActions({
  AVATAR_PICTURE_REMOVED: () => { },
  CHANGE_PROFILE_PICTURE: (data) => (data),
  CHANGE_PROFILE_PICTURE_FAILED: (data) => (data),
  CHANGE_PROFILE_PICTURE_RESTART: () => { },
  CHANGE_PROFILE_PICTURE_SUCCESS: () => { },
  CLEAR_NAMES_UPDATE_ERROR: () => { },
  COVER_PICTURE_REMOVED: () => { },
  DISCOUNT_DATA_LOADED: (data) => data,
  DO_PET_LOAD: (data) => data,
  FIRST_NAME_CHANGED: (data) => data,
  GET_DISCOUNT_INFO: (data) => data,
  GET_TELUS_DOCS: () => { },
  LAST_NAME_CHANGED: (data) => data,
  LAST_NAME_RESET: () => { },
  NAMES_UPDATED: (data) => data,
  PETS_LOAD_ATTEMPT: () => { },
  PETS_LOADED: (data) => data,
  PETS_LOADED_FINISHED: () => { },
  PHONES_UPDATED: (data) => data,
  REFRESH_PERSONAL_INFORMATION: (data) => (data),
  REFRESH_PETS: () => { },
  REMOVE_AVATAR_PICTURE: () => { },
  REMOVE_AVATAR_PICTURE_FAILED: () => { },
  REMOVE_COVER_PICTURE: () => { },
  REMOVE_COVER_PICTURE_FAILED: () => { },
  SAVE_USER_INFO_ADDRESS: (data) => data,
  SOCIAL_PROFILE_LOAD_ATTEMPT: () => { },
  SOCIAL_PROFILE_LOADED: (data) => data,
  SOCIAL_PROFILE_LOADED_FINISHED: () => { },
  STORE_STATES: (data) => data,
  TELUS_DOCS_FAILED: () => { },
  TELUS_DOCS_LOADED: (data) => data,
  UPDATE_INSURANCE_INFORMATION: (data) => data,
  UPDATE_INSURANCE_INFORMATION_FAILED: () => { },
  UPDATE_INSURANCE_INFORMATION_SUCCESS: () => { },
  UPDATE_NAMES: (data) => data,
  UPDATE_NAMES_FAILED: (data) => data,
});

export const {
  avatarPictureRemoved,
  changeProfilePicture,
  changeProfilePictureFailed,
  changeProfilePictureRestart,
  changeProfilePictureSuccess,
  clearNamesUpdateError,
  coverPictureRemoved,
  discountDataLoaded,
  doPetLoad,
  firstNameChanged,
  getDiscountInfo,
  getTelusDocs,
  lastNameChanged,
  lastNameReset,
  namesUpdated,
  petsLoadAttempt,
  petsLoaded,
  petsLoadedFinished,
  phonesUpdated,
  refreshPersonalInformation,
  refreshPets,
  removeAvatarPicture,
  removeAvatarPictureFailed,
  removeCoverPicture,
  removeCoverPictureFailed,
  saveUserInfoAddress,
  socialProfileLoadAttempt,
  socialProfileLoaded,
  socialProfileLoadedFinished,
  storeStates,
  telusDocsFailed,
  telusDocsLoaded,
  updateInsuranceInformation,
  updateInsuranceInformationFailed,
  updateInsuranceInformationSuccess,
  updateNames,
  updateNamesFailed,
} = actions;
